const t = "styles-module__single_room___mY2lb", e = "styles-module__title___rS9S9", l = {
  single_room: t,
  title: e
};
export {
  l as default,
  t as single_room,
  e as title
};
